import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tubiao",
  "use": "icon-tubiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tubiao\"><path d=\"M741.99552 86.25152 831.03744 175.29344 545.29024 422.54848 337.8176 228.81792 333.4912 223.81568 332.9536 224.27648 332.46208 223.81568 328.12032 228.45952 66.56 454.784 66.56 540.14976 67.17952 540.86656 331.28448 312.33024 545.35168 512.21504 560.47104 496.02048 877.47584 221.72672 957.44 301.69088 957.44 86.25152ZM66.56 937.74848 170.06592 937.74848 170.06592 571.56096 66.56 668.19584ZM566.528 937.74848 670.03392 937.74848 670.03392 489.92256 566.528 579.74784ZM316.544 489.92256 316.544 937.74848 420.05504 937.74848 420.05504 483.77344 369.96096 427.55584ZM816.512 403.87584 816.512 937.74848 920.01792 937.74848 920.01792 390.13888 869.92896 350.06976Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tubiao.svg
// module id = nQME
// module chunks = 11